import React, { Component } from 'react';
import "./ShopsPopup.scss"
import { push } from '../../Services/Analytics';

class ShopsPopup extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    handleClick() {
        push("Buy_online_clicked", "");
    }
    render() {
        return (
            <div className="shops">
                <div className="headline">
                    <div className="teaser">
                        לרכישת המכשיר בחנויות המורשות
                    </div>
                    <div className="lglogo"></div>
                </div>
                <div className="logos">
                    <div className="hot"><a href="https://store.hotmobile.co.il/hotprivate/cell-phones/lg-g7-black.html" target="_blank"></a></div>
                    <div className="cell"><a href="https://www.cellcom.co.il/store/devices/cellphones/item/g7/1729" target="_blank"></a></div>
                    <div className="partner nolink"></div>
                    <div className="pelephone"><a href="https://www.pelephone.co.il/digitalsite/heb/shop/product/devices/lg/lg-g7/" target="_blank"></a></div>
                    <div className="ivory"><a href="https://www.ivory.co.il/catalog.php?id=25996" target="_blank"></a></div>
                    <div className="bug"><a href="https://www.bug.co.il/prodtxt.asp?id=29600" target="_blank"></a></div>
                    <div className="ksp"><a href="https://ksp.co.il/?select=.272..573..134.&kg=&list=1&sort=2&glist=0&uin=49055&txt_search=&buy=&minprice=0&maxprice=0&intersect=&rintersect=&store_real" target="_blank"></a></div>
                    <div className="best"><a href="https://www.bestmobile.co.il/500-lgg7ro-10.html" target="_blank"></a></div>
                    <div className="hashmal"><a href="https://www.payngo.co.il/smartphones/smartphones/smartphones/238095.html" target="_blank"></a></div>
                    <div className="patkom nolink"></div>
                    <div className="office"><a href="http://www.officedepot.co.il/items/1832549-%D7%98%D7%9C%D7%A4%D7%95%D7%9F-%D7%A1%D7%9C%D7%95%D7%9C%D7%A8%D7%99-LG-G7-ThinQ-LMG710EM-64GB-%D7%A9%D7%97%D7%95%D7%A8-%D7%90%D7%9C-%D7%92-%D7%99" target="_blank"></a></div>
                    <div className="dynamic"><a href="https://www.dynamica.co.il/items/1826078-%D7%98%D7%9C%D7%A4%D7%95%D7%9F-%D7%A1%D7%9C%D7%95%D7%9C%D7%A8%D7%99-%D7%9E%D7%A1%D7%95%D7%92-LG-G7-ThinQ" target="_blank"></a></div>
                </div>
            </div>
        );
    }
}

export default ShopsPopup;



// WEBPACK FOOTER //
// ./src/Components/Helpers/Popup/ShopsPopup.jsx